// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row{display:flex}.col{display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./src/components/Common/Container/Container.scss"],"names":[],"mappings":"AAAA,KACE,YAAA,CAGF,KACE,YAAA,CACA,qBAAA","sourcesContent":[".row {\n  display: flex;\n}\n\n.col {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
